// Preço por uso de cada poção (cobrado do banco a cada uso pela barra de ações ou pelo Auto Helper).
import { POTION_PRICES } from '../../../shared/src/game/potionPrices';
import { catalogNow } from './items';
import { spellsNow } from './spells';

const BY_NAME = new Map(POTION_PRICES.map(([n, price]) => [n, price]));
export function potionPriceByName(name: string): number | undefined { return BY_NAME.get(name.toLowerCase()); }
export function potionPrice(typeId: number): number | undefined {
  const n = catalogNow()?.get(typeId)?.name;
  return n ? potionPriceByName(n) : undefined;
}
/** custo por uso de um item da barra: poção (preço da loja) ou runa (preço do NPC de magia) */
export function itemCost(typeId: number): number | undefined {
  const p = potionPrice(typeId);
  if (p !== undefined) return p;
  const r = spellsNow()?.find((x) => x.kind === 'rune' && x.item === typeId);
  return r?.price ?? undefined;
}
/** 1.250 → "1,2k", 25.000 → "25k" (cabe no canto do espaço da barra) */
export function shortGp(n: number): string {
  if (n >= 10_000) return Math.round(n / 1000) + 'k';
  if (n >= 1000) return (n / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 1 }) + 'k';
  return String(n);
}
